import React, { Component } from 'react';
import { Example, Properties, SourceCode } from 'examples';
import Checkbox from '../Checkbox/Checkbox';
import InfiniteScroll from './InfiniteScroll';
import Progressbar from '../Progressbar/Progressbar';

const PAGE_SIZE = 25;

export default class InfiniteScrollExample extends Component {

  constructor(props) {
    super(props);
    this.state = {
      items: [],
      delayLoad: false,
    };
    this.start = 1;
    this.hasMoreCalled = 0;
    this.loadMoreCalled = 0;
  }

  componentDidMount() {
    this.setState({ items: this.load() }); // eslint-disable-line react/no-did-mount-set-state
  }

  onChange = e => this.setState(e.target.value);

  onToggleDelay = e => this.setState({ delayLoad: !this.state.delayLoad, items: this.state.items.slice(0, 100) }); // eslint-disable-line no-return-assign

  hasMore = () => {
    ++this.hasMoreCalled;
    return this.state.delayLoad ? this.state.items.length < 100 : true;
  };

  loadMore = () => {
    ++this.loadMoreCalled;
    this.setState({ loading: true });
    setTimeout(() => {
      this.setState({
        items: [...this.state.items, ...this.load()],
        loading: false,
      });
    }, this.state.delayLoad ? 2000 : 0);
  };

  load = () => {
    const items = [];

    for (let i = this.start; i < this.start + PAGE_SIZE; i++) {
      items.push(`Item ${i}`);
    }
    this.start += PAGE_SIZE;
    return items;
  };

  pageStart = () => this.state.items.length;

  render() {
    const { delayLoad, loading, items = [], ...rest } = this.state;
    const list = items.map(item => <div key={item} className="item">{item}</div>);

    return (
      <Example {...this.props}>
        <Properties onChange={this.onChange} defaultProps={InfiniteScroll.defaultProps} propTypes={InfiniteScroll.propTypes} propValues={this.state}/>
        <div className="example-scroller">
          <div className="core-infinite-scroll-wrapper">
            <InfiniteScroll {...rest} loadMore={this.loadMore} pageStart={this.pageStart} hasMore={this.hasMore}>
              {list}
              {loading && <Progressbar className="core-infinite-scroll-progress" circular indeterminate/>}
            </InfiniteScroll>
          </div>
          <div className="log">
            <div className="info count">{items.length}</div>
            <div className="info has-more">{this.hasMoreCalled}</div>
            <div className="info load-more">{this.loadMoreCalled}</div>
          </div>
        </div>
        <Checkbox checked={delayLoad} onChange={this.onToggleDelay} label="Delay loading by 2 seconds and limit items to 100"/>
        <SourceCode querySelector=".example-scroller .core-infinite-scroll"/>
      </Example>
    );
  }

}
